import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

class AdminRoute extends Component {
  state = {
    isAdmin: false,
  };

  componentWillMount() {
    const user = localStorage.getItem('user');
    if (user) {
      this.setState({
        isAdmin: JSON.parse(user).isAdmin,
      });
    }
  }

  render() {
    const { component: ComponentToRender, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={(props) => {
          if (this.state.isAdmin) {
            return (
              <ComponentToRender {...props} />
            );
          }
          return (
            <Redirect
              to={{
                pathname: '/app',
                state: { from: props.location },
              }}
            />
          );
        }}
      />
    );
  }
}

AdminRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default AdminRoute;



// WEBPACK FOOTER //
// ./src/routes/AdminRoute.jsx